/** Staff users who interact with the platform: submitting items, routing approvals, and administering the system. */
export const usersCube = {
    category: 'Legislation',
    description: 'Staff users who submit items, route approvals, and manage workflows.',
    label: 'Users',
    measures: {
        'users.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'users.display_name': { label: 'Display Name', type: 'string' },
        'users.email': { label: 'Email', type: 'string' },
        'users.first_name': { label: 'First Name', type: 'string' },
        'users.last_name': { label: 'Last Name', type: 'string' },
        'users.membership_status': { label: 'Status', type: 'string' },
    },
    timeDimensions: {
        'users.last_login_at': { label: 'Last Login At', type: 'date' },
        'users.created_at': { label: 'Created At', type: 'date' },
    },
};
